import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Shows a server timestamp (<time datetime="...">) in the viewer's own time
// zone. The server-rendered text is a UTC fallback for when JS hasn't run.
export default class extends Controller {
  static values = { format: { type: String, default: "time" } }

  connect() {
    const date = new Date(this.element.getAttribute("datetime"))
    if (Number.isNaN(date.getTime())) return

    this.element.title = date.toLocaleString([], { dateStyle: "full", timeStyle: "short" })
    this.element.textContent = this.formatValue === "relative" ? relative(date) : clock(date)
  }
}

function clock(date) {
  const time = date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
  if (isSameDay(date, new Date())) return time
  const day = date.toLocaleDateString([], { month: "short", day: "numeric" })
  return `${day}, ${time}`
}

function relative(date) {
  const seconds = Math.round((date - Date.now()) / 1000)
  const format = new Intl.RelativeTimeFormat([], { numeric: "auto" })
  if (Math.abs(seconds) < 60) return t("javascript.controllers.local_time_controller.just_now")
  if (Math.abs(seconds) < 3600) return format.format(Math.round(seconds / 60), "minute")
  if (isSameDay(date, new Date())) return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })

  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  if (isSameDay(date, yesterday)) return format.format(-1, "day")
  const sameYear = date.getFullYear() === new Date().getFullYear()
  return date.toLocaleDateString([], sameYear ? { month: "short", day: "numeric" } : { dateStyle: "medium" })
}

function isSameDay(a, b) {
  return a.toDateString() === b.toDateString()
}
